// extracted by mini-css-extract-plugin
export default {"orderTimeline":"OrderTimeline_orderTimeline__R0Srk","titleDiv":"OrderTimeline_titleDiv__tRV1X","title":"OrderTimeline_title__E2io3","line":"OrderTimeline_line__OZsi0"};